// extracted by mini-css-extract-plugin
export default {"container":"ProjectHelpPage7_container__hoEHm","text":"ProjectHelpPage7_text__Ys3tp","imageExampleSync":"ProjectHelpPage7_imageExampleSync__KzqxL"};